import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";

const hostname = import.meta.env.VITE_APP_HOST_NAME;
const twitterUsername = import.meta.env.VITE_APP_TWITTER_USERNAME;

const MetaDecorator = ({ title, description, imageUrl, imageAlt }) => {
  const url =
    hostname + "/" + window.location.pathname + window.location.search;

  const [titleMeta, setTitleMeta] = useState(title);
  const [descriptionMeta, setDescriptionMeta] = useState(description);
  const [imageUrlMeta, setImageUrlMeta] = useState(imageUrl);
  const [imageAltMeta, setImageAltMeta] = useState(imageAlt);

  useEffect(() => {
    setTitleMeta(title);
    setDescriptionMeta(description);
    setImageUrlMeta(imageUrl);
    setImageAltMeta(imageAlt);
  }, [title, description, imageUrl, imageAlt]);

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={titleMeta} />
      <meta name="description" content={descriptionMeta} />
      <meta property="og:description" content={descriptionMeta} />
      <meta property="og:image" content={hostname + imageUrlMeta} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image:alt" content={imageAltMeta} />
      <meta name="twitter:site" content={twitterUsername} />
    </Helmet>
  );
};

export default MetaDecorator;
